import Alerts from "../../util/Alerts";
import { Card, CardBody, CardTitle, Label } from "reactstrap";
import React, { useRef } from "react";
import { useUser } from "../../custom-hooks/useUser";
import { HOME_PATH } from "../../components/Navbars/navbar.constants";
import { useHistory } from "react-router-dom";
import BlkFormik from "../../util/BlkFormik";
import { Form, FormikHelpers, FormikProps } from "formik";
import { BlkField } from "../../coms/BlkField";
import { resetTotpSchema } from "./schemas/reset-totp.schema";
import axios from "axios";
import { routes } from "../../gen/General";
import { Alert } from "../../interface/alert.interface";
import { ProdesegButton, ProdesegButtonEnumTypes } from "../../components/ProdesegButton/ProdesegButton";

interface ResetTOTP {
    email: string;
}

const initialResetForm: ResetTOTP = {
    email: "",
};

export const AdminTOTP = () => {
    const { adminTOTP } = useUser();
    const history = useHistory();

    const alertRef: React.MutableRefObject<Alert | undefined> = useRef();

    if (!adminTOTP) history.push(HOME_PATH);

    const onSubmit = (values: ResetTOTP, { setSubmitting }: FormikHelpers<ResetTOTP>) => {
        axios
            .post(routes.apiVam + "/usuario/reset-totp", values, { headers: { "X-RESET-TOTP": "true" } })
            .then(() => alertRef.current?.show_info("Se ha restablecido el MFA de forma correcta."))
            .catch(error => {
                alertRef.current?.show_error(
                    "No se ha podido restablecer el MFA, si esto continua contáctese con soporte."
                );
                console.error(error);
            })
            .finally(() => setSubmitting(false));
    };

    return (
        <>
            <Alerts ref={alertRef} />
            <Card>
                <CardBody>
                    <CardTitle tag="h4">Administración MFA</CardTitle>
                    <div className={"container"}>
                        <BlkFormik
                            initialValues={initialResetForm}
                            onSubmit={onSubmit}
                            validationSchema={resetTotpSchema}
                            validateOnChange
                        >
                            {(actions: FormikProps<ResetTOTP>) => (
                                <Form>
                                    <div className={"row"}>
                                        <span className="text-primary-900 font-weight-medium h2">Restablecer MFA</span>
                                    </div>
                                    <div className={"row my-2-1"}>
                                        <div className={"col-12 col-lg-6 form-group"}>
                                            <Label>Email*:</Label>
                                            <BlkField
                                                name={"email"}
                                                placeholder={"Email del Usuario"}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                    <div className={"row"}>
                                        <div className="col-12">
                                            <ProdesegButton
                                                type={ProdesegButtonEnumTypes.Primary}
                                                onClick={actions.submitForm}
                                                isDisabled={actions.isSubmitting}
                                                isOutline
                                            >
                                                Restablecer
                                            </ProdesegButton>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </BlkFormik>
                    </div>
                </CardBody>
            </Card>
        </>
    );
};
